import { getMessage } from '@gef-ui/localization/messages';
export const resolveFieldLabel = ({ fieldName, messageKey, messageNamespace, localizedLabel })=>{
    if (localizedLabel) {
        return localizedLabel;
    } else if (messageNamespace) {
        return getMessage(`${messageNamespace}:${messageKey || fieldName}`);
    } else if (messageKey) {
        return getMessage(messageKey);
    } else {
        return getMessage(fieldName);
    }
};
